module.exports = __webpack_public_path__ + "img/hm.2fc018a9.svg";